var styles = {"span":"Span-module_span__p26bQ"};

export { styles as default };
//# sourceMappingURL=Span.module.scss.js.map
